import React, {FC, useMemo} from 'react';
import shortid from 'shortid';
import FormControl, {SharedFormControlProps} from './FormControl';
import FieldsetFormControl from './FieldsetFormControl';

export {default as FullStoryMask, validFullStoryLevels} from './FullStoryMask';
export type {FullStoryLevel, FullStoryMaskProps} from './FullStoryMask';
export {default as FormControl} from './FormControl';
export {default as FieldsetFormControl} from './FieldsetFormControl';
export {default as formControlPropTypes} from './common-prop-types';
export {default as formControlDefaultProps} from './common-default-props';
export {default as Label} from './Label';
export {default as Legend} from './Legend';
export {default as Help} from './Help';
export {default as InputWrapper} from './InputWrapper';
export {default as ValidationIcon} from './ValidationIcon';
export {ErrorMessage, InfoMessage} from './ErrorMessage';

export const fieldsetInputTypes = ['RadioGroup', 'CheckboxGroup', 'Radio', 'Checkbox', 'ToggleInput', 'ToggleButton'];

export interface DecideWhichFormControlToUseProps extends SharedFormControlProps {
  children: any;
  fieldset?: boolean;
  id?: string;
  label: string;
  [key: string]: unknown;
}

const DecideWhichFormControlToUse: FC<DecideWhichFormControlToUseProps> = props => {
  const {fieldset, id: customId, children} = props;

  const id = useMemo(() => customId || shortid.generate(), [customId]);

  if (fieldset || (children && fieldsetInputTypes.includes(children.type.displayName))) {
    return <FieldsetFormControl {...props} id={id} />;
  }

  return <FormControl {...props} id={id} />;
};

export default DecideWhichFormControlToUse;
